"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelOrderCargo = cancelOrderCargo;
exports.cancelOrderSchedule = cancelOrderSchedule;
exports.subscribeCargo = subscribeCargo;
exports.subscribeSchedule = subscribeSchedule;
exports.voyageInfoSearch = voyageInfoSearch;
exports.voyageTsInfoSearch = voyageTsInfoSearch;
var _request = _interopRequireDefault(require("@/utils/request"));
/**
 * 船期查询
 * @param query
 */
function voyageInfoSearch(query) {
  return (0, _request.default)({
    url: '/equery/voyageInfo/searchPlan',
    method: 'post',
    params: query
  });
}

/**
 * 中转船期查询
 * @param query
 */
function voyageTsInfoSearch(query) {
  return (0, _request.default)({
    url: '/equery/voyageInfo/searchTsPlan',
    method: 'post',
    params: query
  });
}

/**
 * 船期订阅
 * @param query
 */
function subscribeSchedule(data) {
  return (0, _request.default)({
    url: '/equery/ecomVoyagePlanOrder/order',
    method: 'post',
    data: data
  });
}

/**
 * 取消订阅
 * @param query
 */
function cancelOrderSchedule(id) {
  return (0, _request.default)({
    url: '/equery/ecomVoyagePlanOrder/cancelOrder/' + id,
    method: 'post'
  });
}

/**
 * 货物跟踪订阅
 * @param query
 */
function subscribeCargo(data) {
  return (0, _request.default)({
    url: '/equery/ecomCargoTrackOrder/order',
    method: 'post',
    data: data
  });
}

/**
 * 货物跟踪取消订阅
 * @param query
 */
function cancelOrderCargo(id) {
  return (0, _request.default)({
    url: '/equery/ecomCargoTrackOrder/cancelOrder/' + id,
    method: 'post'
  });
}